import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Contact } from 'src/app/_models/contact.model';

@Component({
  selector: 'DCO-contacts-list',
  templateUrl: './contacts-list.component.html',
  standalone: false,
})
export class ContactListComponent {

  @Input() contacts: Contact[] = [];   // Lista de contactos
  @Input() checkboxes: boolean = false;  // Mostrar checkboxes o no
  @Input() checkboxesDisabled: boolean = false;    // Deshabilitar los checkboxes

  // Emitir cuando los contactos seleccionados cambien
  @Output() selectedContactsChange = new EventEmitter<Contact[]>();

  // Seleccionar checkbox (Contact)
  onCheckboxChange(): void {
    // console.log(this.contacts)
    // Filtra los contactos seleccionados
    const selectedContacts = this.contacts
      .filter(contact => contact.selected);

    // Emitimos los contactos seleccionados
    this.selectedContactsChange.emit(selectedContacts);
  }

  // Desmarcar todos los checkboxes (Contact)
  clearCheckboxes(): void {
    this.contacts.forEach(contact => {
      contact.selected = false;
    });
    // Emitimos que no hay ningun contacto seleccionado
    this.selectedContactsChange.emit([]);
  }

  setAllCheckboxes(select: boolean): void {
    if (this.contacts && this.contacts.length > 0) {
      this.contacts.forEach(contact => contact.selected = select);

      const updatedSelection = select ? [...this.contacts] : [];

      this.selectedContactsChange.emit(updatedSelection);
    }
  }
}
